module.exports = __webpack_public_path__ + "img/logo_trade.84325fff.png";